import React from 'react';
import styled from 'styled-components';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import config from '../config';
import theme from '../theme';
import { updatePollScoresFb, SET_SCORE, SET_BACKGROUND } from '../db';
import { IAppState } from '../db/reducers';

const SScore = styled.div`
  justify-content: flex-start; 
  align-items: flex-start;
  height: 100vh;
  width: 100vw;
`

const SHeaderDiv = styled.div`
  display: flex;
  margin-top: 3vh;
`;

const SRowDiv = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  width: 100vw;
`;

const SScoreText = styled.p`
  display: flex;
  font-size: 30vh;
  margin: 0 0 0 0;
  color: ${theme.textSecondary};
`;

const SSpanNav = styled.span`
  display: flex;
  padding-left: 1vw;
  align-items: flex-start;
  justify-content: flex-start;
`;

const SScoreTextNav = styled.p`
  display: flex;
  font-size: 1vh;
  margin: 0 0 0 0;
  align-self: center;
  color: ${theme.textSecondary};
`;

const SBackArrow = styled.img`
  display: flex;
`;

interface IScoreProps extends RouteComponentProps {
  pollId: string;
  currentUserScore: number;
  submitUserScore(pollId: string, currentUserScore: number): void;
  resetUserScore(currentUserScore: number): void;
  setBackgroundColor(color: string): void;
}

class Score extends React.Component<IScoreProps> {
  componentDidMount() {
    const { setBackgroundColor, currentUserScore } = this.props;
    const color = config.formScale[currentUserScore].color;
    setBackgroundColor(color);

    /**
     * LOAD TESTING
     *
     * const {
     *  submitUserScore,
     *  pollId,
     *  history,
     * } = this.props;
     *
     * let score = currentUserScore;
     *  let count = 0;
     *
     *  setTimeout(async () => {
     *    await console.log('waiting');
     *    history.push(`/p/${pollId}/thanks`);
     *    async function timeout() {
     *      await setTimeout(function() {
     *        const min = Math.ceil(1);
     *        const max = Math.floor(11);
     *        score = Math.floor(Math.random() * (max - min)) + min;
     *        submitUserScore(pollId, score);
     *        count += 1;
     *        if (count > 2000) {
     *          return;
     *        } else timeout();
     *      }, 500);
     *    }
     *    if (score !== 0) {
     *      timeout();
     *    }
     *  }, 8000);
     */
  }

  sendScore = (event: any) => {
    event.preventDefault();
    const { history, currentUserScore, pollId, submitUserScore } = this.props;
    submitUserScore(pollId, currentUserScore);
    history.push(`/p/${pollId}/thanks`);
  };

  chooseAgain = (event: any) => {
    event.preventDefault();
    const { resetUserScore } = this.props;
    resetUserScore(0);
  };

  render() {
    const { currentUserScore } = this.props;
    const { desc } = config.formScale[currentUserScore];

    return (
      <SScore className='Score'>
        <SHeaderDiv className='nav'>
          <SSpanNav onClick={this.chooseAgain}>
            <SBackArrow
              src={process.env.PUBLIC_URL + '/backArrw.png'}
              alt='back'
            />
            <SScoreTextNav className='ScoreText'>Choose Again</SScoreTextNav>
          </SSpanNav>
        </SHeaderDiv>
        <SRowDiv className='body'>
          <SScoreText className='ScoreText' style={{ margin: '15vh 0 0 0' }}>
            {currentUserScore}
          </SScoreText>
          <SScoreText className='ScoreText' style={{ fontSize: '200%', margin: '0 0 5vh 0' }}>
            {desc}
          </SScoreText>
          <button
            onClick={this.sendScore}
            style={{
              color: `${theme.textSecondary}`,
              border: `2px solid ${theme.textSecondary}`,
              padding: '1rem 3rem 1rem 3rem'
            }}
          >
            Share it!
          </button>
        </SRowDiv>
      </SScore>
    );
  }
}

const mapStateToProps = (state: IAppState) => {
  return { currentUserScore: state.currentUserScore };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    submitUserScore: async (
      currentPollId: string,
      currentUserScore: number
    ) => {
      dispatch({ type: SET_SCORE, currentUserScore });
      dispatch({ type: SET_BACKGROUND, background: theme.background });
      await updatePollScoresFb(currentPollId, currentUserScore)(dispatch);
    },
    resetUserScore: (currentUserScore: number) => {
      dispatch({ type: SET_SCORE, currentUserScore });
      dispatch({ type: SET_BACKGROUND, background: theme.background });
    },
    setBackgroundColor: (color: string) => {
      dispatch({ type: SET_BACKGROUND, background: color });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Score);
